import { combineReducers } from "redux";
import { cookiesReducer } from "../Reducers/cookiesReducer";
import stateReducer from "./stateReducer";
import { configReducer } from "./configReducer";
import { languageReducer } from "./languageReducer";
import { reducer as oidcReducer } from "redux-oidc";
import messageReducer from "./messageReducer";

const rootReducer = () =>
  combineReducers({
    cookies: cookiesReducer,
    state: stateReducer,
    config: configReducer,
    language: languageReducer,
    oidc: oidcReducer,
    message: messageReducer,
  });

export default rootReducer;
